export const getElementTop = (element) => {
  if (!element) return
  let actualTop = element.offsetTop;
  let current = element.offsetParent;

  while (current !== null) {
    actualTop += current.offsetTop;
    current = current.offsetParent;
  }

  return actualTop;
};


export const isIphonex = () => {
  let isp = /iphone/gi.test(window.navigator.userAgent),
    dpr = window.devicePixelRatio,
    dpi = window.devicePixelRatio,
    w = window.screen.width,
    h = window.screen.height;
  // iPhone X、iPhone XS
  let isIPhoneX = isp && dpr && dpi === 3 && w === 375 && h === 812;
  // iPhone XS Max
  let isIPhoneXSMax = isp && dpr && dpi === 3 && w === 414 && h === 896;
  // iPhone XR
  let isIPhoneXR = isp && dpr && dpi === 2 && w === 414 && h === 896;

  if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) return true
  return false
}

export const isLongScreen = () => {
  let ratio = window.devicePixelRatio || 1;
  let screen = {
    width: window.screen.width * ratio,
    height: window.screen.height * ratio
  };
  if (screen.height / screen.width >= 810 / 375) {
    return true;
  } else {
    return false;
  }
};

export const isBieyangApp = (): boolean => {
  try {
    const ua = window?.navigator?.userAgent || ''
    return /Bieyang/i.test(ua)
  } catch (error) {}
}

export const idDev = process.env.NODE_ENV === 'development'